import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { MoedasInbound } from 'src/app/domain/constants/moeda.constant';
import { CurrencyDto } from 'src/app/domain/models/dto/currency.dto';

@Component({
  selector: 'app-currency-selection',
  templateUrl: './currency-selection.component.html',
  styleUrls: ['./currency-selection.component.scss'],
})
export class CurrencySelectionComponent implements OnInit, OnDestroy {
  @Output('currencySelected') currencySelected: EventEmitter<string> =
    new EventEmitter(null);
  @Input() warrenGlobalOnly?: boolean;

  currencies?: CurrencyDto[] = MoedasInbound;

  constructor() {}

  ngOnDestroy(): void {}

  select(id: string) {
    this.currencySelected.emit(id);
  }

  ngOnInit(): void {
    if (this.warrenGlobalOnly) {
      this.currencies = MoedasInbound.filter((moeda) => moeda.id === 1);
    } else {
      this.currencies = MoedasInbound;
    }
  }
}
